import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_arrayReduce-35053fa6.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import { _ as _isFunction } from './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './reduce-359d9da9.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import { _ as _map } from './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import './Typographies.js';
import './index-f96168ba.js';
import Link from './Link.js';
import { _ as _isNull, a as _isUndefined } from './isNull-db706d68.js';
import { c as chain } from './chain-d06384bf.js';

/**
 * A breadcrumb element
 */

var ElementType = PropTypes.shape({
  /** Element's display name */
  name: PropTypes.string.isRequired,

  /** Element's url */
  url: PropTypes.string
});
/**
 * Elements of this breadcrumb.
 * Must be sorted.
 */

var ElementsType = PropTypes.arrayOf(ElementType);

// @noSnapshot
/**
 * A breadcrumb element.
 */

var BreadcrumbElement = function BreadcrumbElement(_ref) {
  var element = _ref.element;
  return React.createElement(Link, {
    href: element.url,
    onClick: element.onClick
  }, element.name);
};

BreadcrumbElement.propTypes = {
  /**
   * Breadcrumb element.
   */
  element: ElementType.isRequired
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var fonts = css(["font-size:", ";font-weight:", ";font-family:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.breadcrumb.fonts.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.breadcrumb.fonts.fontWeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.breadcrumb.fonts.fontFamily;
});
var BreadcrumbSeparator = styled.span(_templateObject(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.breadcrumb.breadcrumbSeparator.color;
}, fonts, function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.breadcrumb.breadcrumbSeparator.spaces.marginLeft;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.breadcrumb.breadcrumbSeparator.spaces.marginRight;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var fonts$1 = css(["font-size:", ";font-weight:", ";font-family:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.breadcrumb.fonts.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.breadcrumb.fonts.fontWeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.breadcrumb.fonts.fontFamily;
});
var CurrentElement = styled.span(_templateObject$1(), fonts$1, function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.breadcrumb.currentElement.colors.text;
});

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var fonts$2 = css(["font-size:", ";font-weight:", ";font-family:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.breadcrumb.fonts.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.breadcrumb.fonts.fontWeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.breadcrumb.fonts.fontFamily;
});
var StyledBreadcrumb = styled.div(_templateObject$2(), fonts$2);

function _templateObject$3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A breadcrumb component.
 */

var Breadcrumb = function Breadcrumb(_ref) {
  var elements = _ref.elements,
      renderElement = _ref.renderElement,
      separator = _ref.separator,
      rest = _objectWithoutProperties(_ref, ["elements", "renderElement", "separator"]);

  var displayElement = function displayElement(element) {
    return chain( // We assume a valid result as soon as we got a non null element
    function (element) {
      return !_isNull(element) && !_isUndefined(element);
    }, // Most precise, we got a custom render function for THAT element
    function () {
      return element && element.render && _isFunction(element.render) ? element.render(element) : null;
    }, // A little less precise, we got a custom render function for each item
    function () {
      return renderElement && _isFunction(renderElement) ? renderElement(element) : null;
    }, // Least precise, neither other function returned something, we default to some hand made rendering
    function () {
      return React.createElement(React.Fragment, null, element.url && React.createElement(BreadcrumbElement, {
        element: element
      }), !element.url && React.createElement(CurrentElement, null, element.name));
    });
  };

  return React.createElement(StyledBreadcrumb, rest, _map(elements, function (element, index, elements) {
    return React.createElement(React.Fragment, {
      key: element.name
    }, displayElement(element), index + 1 < elements.length && React.createElement(BreadcrumbSeparator, null, separator));
  }));
};

Breadcrumb.defaultProps = {
  separator: ' / ',
  renderElement: null
};
Breadcrumb.propTypes = {
  /**
   * Array elements of this breadcrumb.
   * Should be sorted.
   */
  elements: ElementsType.isRequired,

  /**
   * Separator character to put between links.
   */
  separator: PropTypes.string,

  /**
   * The function to use for rendering of each element
   */
  renderElement: PropTypes.func
};
/** @component */

var index = styled(Breadcrumb)(_templateObject$3());

export default index;
